module.exports = __webpack_public_path__ + "img/技能人才评价.17931151.png";